import { keyframes } from 'styled-components';
var spinKeyframes = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
export default spinKeyframes;